"use client"

import React from 'react';
import styles from "./Segments.module.css"
import {Skeleton} from "@mui/material";

export default function Preload() {
  return <div className={styles.skeleton}>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={350}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={100}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={30}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={20}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={20}/>
    <Skeleton variant="rectangular" animation={"pulse"} width={'100%'} height={20}/>
  </div>
}
